/**
 * NOTE:
 * - R6 April [amended:改定]
 */

import { t } from "i18next"
import { Version, getCurrentVersion } from "@project/shared"
import { Moment } from "moment"
import { FormFieldsProp } from "../../../../molecules/FormFields/types"
import { ADDITIONAL_ALLOWANCE_FOR_CHILD_INSTRUCTORS_OPTION } from "../constants"

type Params = {
  name: string
}

const FIELD_LABEL = "Additional allowance for child instructors"

/**
 * Version management: Facility Status Form
 * @param {Moment} date
 * @param {Params} params
 * @return {FormFieldsProp|null}
 */
export function getAdditionalAllowance(date: Moment, params: Params) {
  const { version } = getCurrentVersion(date.format("YYYY-MM-DD"))

  switch (version) {
    case Version.BASELINE:
      return baseline(params.name)
    default:
      return r6April(params.name)
  }
}

/**
 * --------------------------------
 * @version R6_APRIL
 * --------------------------------
 */

function r6April(name: string): FormFieldsProp {
  return {
    fieldLabel: FIELD_LABEL,
    isRowFlexed: true,
    isShown: true,
    fields: [
      {
        name,
        fieldType: {
          type: "radio",
          extraOptions: {
            option: [
              {
                label: t("No"),
                value: "0",
              },
            ],
          },
        },
      },
      {
        name,
        fieldType: {
          type: "radio",
          extraOptions: {
            option: ADDITIONAL_ALLOWANCE_FOR_CHILD_INSTRUCTORS_OPTION,
          },
        },
      },
    ],
  }
}

/**
 * --------------------------------
 * @version BASELINE
 * --------------------------------
 */

function baseline(name: string): FormFieldsProp {
  return {
    fieldLabel: FIELD_LABEL,
    isRowFlexed: true,
    isShown: true,
    fields: [
      {
        name,
        fieldType: {
          type: "radio",
          extraOptions: {
            option: [
              {
                label: t("No"),
                value: "0",
              },
              {
                label: t("Child instructor placement addition"),
                value: "1",
              },
              {
                label: t("Child instructor"),
                value: "2",
              },
            ],
          },
        },
      },
    ],
  }
}
